webpackJsonp([70144966829960],{

/***/ 136:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactHelmet = __webpack_require__(9);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ContactPage = function ContactPage() {
	  return _react2.default.createElement(
	    _react2.default.Fragment,
	    null,
	    _react2.default.createElement(
	      _reactHelmet.Helmet,
	      null,
	      _react2.default.createElement(
	        'title',
	        null,
	        'Contact Us'
	      )
	    ),
	    _react2.default.createElement(
	      'h2',
	      null,
	      'Contact Us'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'Please email us at',
	      ' ',
	      _react2.default.createElement(
	        'a',
	        { href: 'mailto:info@artisticcoffee.com' },
	        'info@artisticcoffee.com'
	      ),
	      '.'
	    )
	  );
	};
	
	exports.default = ContactPage;
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-contact-js-baaf86351a84f3b7dacd.js